// firestoreUtils.ts
export function removeUndefined<T extends Record<string, any>>(obj: T): T {
    const cleaned: Record<string, any> = {};
  
    Object.keys(obj).forEach((key) => {
      const value = obj[key];
      if (value !== undefined) {
        cleaned[key] = value;
      }
    });
  
    return cleaned as T;
  }
  